export const DESIGN_CAPABILITY_I18N_KEYS = Object.freeze({
  numericSeries: Object.freeze({
    inspect: "monkeys.design.capability.numericSeries.inspect",
    noPoints: "monkeys.design.capability.numericSeries.noPoints",
    point: "monkeys.design.capability.numericSeries.point",
    label: "monkeys.design.capability.numericSeries.label",
    description: "monkeys.design.capability.numericSeries.description",
    start: "monkeys.design.capability.numericSeries.start",
    end: "monkeys.design.capability.numericSeries.end",
    reset: "monkeys.design.capability.numericSeries.reset",
    expand: "monkeys.design.capability.numericSeries.expand",
    close: "monkeys.design.capability.numericSeries.close",
  }),

  catalog: Object.freeze({
    shellLayout: Object.freeze({
      label: "monkeys.design.catalog.shellLayout.label",
      description: "monkeys.design.catalog.shellLayout.description",
    }),
    sidebarFilter: Object.freeze({
      label: "monkeys.design.catalog.sidebarFilter.label",
      description: "monkeys.design.catalog.sidebarFilter.description",
    }),
    ontologyNavigator: Object.freeze({
      label: "monkeys.design.catalog.ontologyNavigator.label",
      description: "monkeys.design.catalog.ontologyNavigator.description",
    }),
    dataToolbar: Object.freeze({
      label: "monkeys.design.catalog.dataToolbar.label",
      description: "monkeys.design.catalog.dataToolbar.description",
    }),
    ontologyTable: Object.freeze({
      label: "monkeys.design.catalog.ontologyTable.label",
      description: "monkeys.design.catalog.ontologyTable.description",
    }),
    cardGrid: Object.freeze({
      label: "monkeys.design.catalog.cardGrid.label",
      description: "monkeys.design.catalog.cardGrid.description",
    }),
    pagination: Object.freeze({
      label: "monkeys.design.catalog.pagination.label",
      description: "monkeys.design.catalog.pagination.description",
    }),
    recordDetail: Object.freeze({
      label: "monkeys.design.catalog.recordDetail.label",
      description: "monkeys.design.catalog.recordDetail.description",
    }),
    recordEditor: Object.freeze({
      label: "monkeys.design.catalog.recordEditor.label",
      description: "monkeys.design.catalog.recordEditor.description",
    }),
    recordHistory: Object.freeze({
      label: "monkeys.design.catalog.recordHistory.label",
      description: "monkeys.design.catalog.recordHistory.description",
    }),
    ontologyManagement: Object.freeze({
      label: "monkeys.design.catalog.ontologyManagement.label",
      description: "monkeys.design.catalog.ontologyManagement.description",
    }),
    featureColumnManager: Object.freeze({
      label: "monkeys.design.catalog.featureColumnManager.label",
      description: "monkeys.design.catalog.featureColumnManager.description",
    }),
    ontologyTrendMatrix: Object.freeze({
      label: "monkeys.design.catalog.ontologyTrendMatrix.label",
      description: "monkeys.design.catalog.ontologyTrendMatrix.description",
    }),
    dataContextBar: Object.freeze({
      label: "monkeys.design.catalog.dataContextBar.label",
      description: "monkeys.design.catalog.dataContextBar.description",
    }),
    gallery: Object.freeze({
      label: "monkeys.design.catalog.gallery.label",
      description: "monkeys.design.catalog.gallery.description",
    }),
    sectionHeader: Object.freeze({
      label: "monkeys.design.catalog.sectionHeader.label",
      description: "monkeys.design.catalog.sectionHeader.description",
    }),
    notice: Object.freeze({
      label: "monkeys.design.catalog.notice.label",
      description: "monkeys.design.catalog.notice.description",
    }),
    descriptionList: Object.freeze({
      label: "monkeys.design.catalog.descriptionList.label",
      description: "monkeys.design.catalog.descriptionList.description",
    }),
    contentPanel: Object.freeze({
      label: "monkeys.design.catalog.contentPanel.label",
      description: "monkeys.design.catalog.contentPanel.description",
    }),
    toolbar: Object.freeze({
      label: "monkeys.design.catalog.toolbar.label",
      description: "monkeys.design.catalog.toolbar.description",
    }),
    status: Object.freeze({
      label: "monkeys.design.catalog.status.label",
      description: "monkeys.design.catalog.status.description",
    }),
    professionalLeaf: Object.freeze({
      label: "monkeys.design.catalog.professionalLeaf.label",
      description: "monkeys.design.catalog.professionalLeaf.description",
    }),
  }),
  status: Object.freeze({
    loading: Object.freeze({
      title: "monkeys.design.capability.status.loading.title",
      description: "monkeys.design.capability.status.loading.description",
    }),
    empty: Object.freeze({
      title: "monkeys.design.capability.status.empty.title",
      description: "monkeys.design.capability.status.empty.description",
    }),
    error: Object.freeze({
      title: "monkeys.design.capability.status.error.title",
      description: "monkeys.design.capability.status.error.description",
    }),
    forbidden: Object.freeze({
      title: "monkeys.design.capability.status.forbidden.title",
      description: "monkeys.design.capability.status.forbidden.description",
    }),
    retry: "monkeys.design.capability.status.retry.label",
  }),
  shellLayout: Object.freeze({
    resizeSidebar: "monkeys.design.capability.shellLayout.resizeSidebar",
    collapseSidebar: "monkeys.design.capability.shellLayout.collapseSidebar",
    expandSidebar: "monkeys.design.capability.shellLayout.expandSidebar",
    resizeAside: "monkeys.design.capability.shellLayout.resizeAside",
  }),
  sidebarFilter: Object.freeze({
    title: "monkeys.design.capability.sidebarFilter.title",
    searchLabel: "monkeys.design.capability.sidebarFilter.search.label",
    searchPlaceholder:
      "monkeys.design.capability.sidebarFilter.search.placeholder",
    groupLabel: "monkeys.design.capability.sidebarFilter.group.label",
    optionLabel: "monkeys.design.capability.sidebarFilter.option.label",
  }),
  gallery: Object.freeze({
    itemTitle: "monkeys.design.capability.gallery.item.title",
    itemActivate: "monkeys.design.capability.gallery.item.activate",
    loadMore: "monkeys.design.capability.gallery.pagination.loadMore",
    loadingMore: "monkeys.design.capability.gallery.pagination.loadingMore",
  }),
  ontologyNavigator: Object.freeze({
    empty: "monkeys.design.capability.ontologyNavigator.empty",
    moreActions: "monkeys.design.capability.ontologyNavigator.moreActions",
    searchLabel: "monkeys.design.capability.ontologyNavigator.search.label",
    searchPlaceholder:
      "monkeys.design.capability.ontologyNavigator.search.placeholder",
    loadMore: "monkeys.design.capability.ontologyNavigator.loadMore",
    loadingMore: "monkeys.design.capability.ontologyNavigator.loadingMore",
  }),
  dataToolbar: Object.freeze({
    addRow: "monkeys.design.capability.dataToolbar.addRow",
    blankRowName: "monkeys.design.capability.dataToolbar.blankRowName",
    searchPlaceholder:
      "monkeys.design.capability.dataToolbar.search.placeholder",
    selection: "monkeys.design.capability.dataToolbar.selection",
    gallerySettings: "monkeys.design.capability.dataToolbar.gallerySettings",
    galleryPresentation: {
      visibleColumns: "monkeys.design.capability.dataToolbar.galleryPresentation.visibleColumns",
      coverField: "monkeys.design.capability.dataToolbar.galleryPresentation.coverField",
      autoDetect: "monkeys.design.capability.dataToolbar.galleryPresentation.autoDetect",
      cardDensity: "monkeys.design.capability.dataToolbar.galleryPresentation.cardDensity",
      cardColumns: "monkeys.design.capability.dataToolbar.galleryPresentation.cardColumns",
      detailColumns: "monkeys.design.capability.dataToolbar.galleryPresentation.detailColumns",
      fieldVisibility: "monkeys.design.capability.dataToolbar.galleryPresentation.fieldVisibility",
      fieldLimit: "monkeys.design.capability.dataToolbar.galleryPresentation.fieldLimit",
      fieldLimitHint: "monkeys.design.capability.dataToolbar.galleryPresentation.fieldLimitHint",
      layout: "monkeys.design.capability.dataToolbar.galleryPresentation.layout",
      compact: "monkeys.design.capability.dataToolbar.galleryPresentation.compact",
      comfortable: "monkeys.design.capability.dataToolbar.galleryPresentation.comfortable",
      detailed: "monkeys.design.capability.dataToolbar.galleryPresentation.detailed",
      autoColumns: "monkeys.design.capability.dataToolbar.galleryPresentation.autoColumns",
      columns: "monkeys.design.capability.dataToolbar.galleryPresentation.columns",
      bentoColumns: "monkeys.design.capability.dataToolbar.galleryPresentation.bentoColumns",
      topLimit: "monkeys.design.capability.dataToolbar.galleryPresentation.topLimit",
      allFields: "monkeys.design.capability.dataToolbar.galleryPresentation.allFields",
      adaptiveGrid: "monkeys.design.capability.dataToolbar.galleryPresentation.adaptiveGrid",
      masonry: "monkeys.design.capability.dataToolbar.galleryPresentation.masonry",
    },
  }),
  ontologyTable: Object.freeze({
    label: "monkeys.design.capability.ontologyTable.label",
    empty: "monkeys.design.capability.ontologyTable.empty",
    activate: "monkeys.design.capability.ontologyTable.activate",
    select: "monkeys.design.capability.ontologyTable.select",
    sort: "monkeys.design.capability.ontologyTable.sort",
    loadMore: "monkeys.design.capability.ontologyTable.loadMore",
    loadingMore: "monkeys.design.capability.ontologyTable.loadingMore",
  }),
  cardGrid: Object.freeze({
    empty: "monkeys.design.capability.cardGrid.empty",
    activate: "monkeys.design.capability.cardGrid.activate",
    select: "monkeys.design.capability.cardGrid.select",
    loadMore: "monkeys.design.capability.cardGrid.loadMore",
    loadingMore: "monkeys.design.capability.cardGrid.loadingMore",
  }),
  pagination: Object.freeze({
    label: "monkeys.design.capability.pagination.label",
    loadMore: "monkeys.design.capability.pagination.loadMore",
    loadingMore: "monkeys.design.capability.pagination.loadingMore",
  }),
  recordDetail: Object.freeze({
    edit: "monkeys.design.capability.recordDetail.edit",
    close: "monkeys.design.capability.recordDetail.close",
    attachments: "monkeys.design.capability.recordDetail.attachments",
    previous: "monkeys.design.capability.recordDetail.previous",
    next: "monkeys.design.capability.recordDetail.next",
  }),
  recordEditor: Object.freeze({
    submit: "monkeys.design.capability.recordEditor.submit",
    cancel: "monkeys.design.capability.recordEditor.cancel",
    optionsEmpty: "monkeys.design.capability.recordEditor.options.empty",
    optionsLoadMore: "monkeys.design.capability.recordEditor.options.loadMore",
    optionsLoadingMore:
      "monkeys.design.capability.recordEditor.options.loadingMore",
    jsonInvalid: "monkeys.design.capability.recordEditor.json.invalid",
  }),
  recordHistory: Object.freeze({
    title: "monkeys.design.capability.recordHistory.title",
    close: "monkeys.design.capability.recordHistory.close",
    commits: "monkeys.design.capability.recordHistory.commits",
    loadMore: "monkeys.design.capability.recordHistory.loadMore",
    loadingMore: "monkeys.design.capability.recordHistory.loadingMore",
    selected: "monkeys.design.capability.recordHistory.selected",
    diff: "monkeys.design.capability.recordHistory.diff",
    field: "monkeys.design.capability.recordHistory.diff.field",
    before: "monkeys.design.capability.recordHistory.diff.before",
    after: "monkeys.design.capability.recordHistory.diff.after",
    noDiff: "monkeys.design.capability.recordHistory.diff.empty",
    reason: "monkeys.design.capability.recordHistory.reason",
    reasonDescription:
      "monkeys.design.capability.recordHistory.reason.description",
    rollback: "monkeys.design.capability.recordHistory.rollback",
    delete: "monkeys.design.capability.recordHistory.delete",
  }),
  ontologyManagement: Object.freeze({
    title: "monkeys.design.capability.ontologyManagement.title",
    markerDescription: "monkeys.design.capability.ontologyManagement.markerDescription",
    create: "monkeys.design.capability.ontologyManagement.create",
    edit: "monkeys.design.capability.ontologyManagement.edit",
    delete: "monkeys.design.capability.ontologyManagement.delete",
    import: "monkeys.design.capability.ontologyManagement.import",
    description: "monkeys.design.capability.ontologyManagement.description",
    submit: "monkeys.design.capability.ontologyManagement.submit",
    cancel: "monkeys.design.capability.ontologyManagement.cancel",
    displayName:
      "monkeys.design.capability.ontologyManagement.field.displayName",
    label: "monkeys.design.capability.ontologyManagement.field.label",
    templateKey:
      "monkeys.design.capability.ontologyManagement.field.templateKey",
    templateName:
      "monkeys.design.capability.ontologyManagement.field.templateName",
    templateDescription:
      "monkeys.design.capability.ontologyManagement.field.templateDescription",
    templateTags:
      "monkeys.design.capability.ontologyManagement.field.templateTags",
    templateTagsDescription:
      "monkeys.design.capability.ontologyManagement.field.templateTagsDescription",
    creatorCurrentUser:
      "monkeys.design.capability.ontologyManagement.field.creatorCurrentUser",
    creatorCurrentUserShort:
      "monkeys.design.capability.ontologyManagement.field.creatorCurrentUserShort",
    defaultViewTemplatesDescription:
      "monkeys.design.capability.ontologyManagement.field.defaultViewTemplatesDescription",
    defaultViewTemplate:
      "monkeys.design.capability.ontologyManagement.field.defaultViewTemplate",
    defaultSelectedView:
      "monkeys.design.capability.ontologyManagement.field.defaultSelectedView",
    tagFilterEnabled:
      "monkeys.design.capability.ontologyManagement.field.tagFilterEnabled",
    tagFilterEmpty:
      "monkeys.design.capability.ontologyManagement.field.tagFilterEmpty",
    tableColumnsSummary:
      "monkeys.design.capability.ontologyManagement.field.tableColumnsSummary",
    editTemplateDetails:
      "monkeys.design.capability.ontologyManagement.field.editTemplateDetails",
    editTemplateDetailsDescription:
      "monkeys.design.capability.ontologyManagement.field.editTemplateDetailsDescription",
    filterInclude:
      "monkeys.design.capability.ontologyManagement.filter.include",
    filterAny: "monkeys.design.capability.ontologyManagement.filter.any",
    filterExclude:
      "monkeys.design.capability.ontologyManagement.filter.exclude",
    filterNoTags: "monkeys.design.capability.ontologyManagement.filter.noTags",
    filterSearch: "monkeys.design.capability.ontologyManagement.filter.search",
    filterTagGroup:
      "monkeys.design.capability.ontologyManagement.filter.tagGroup",
    filterAllGroups:
      "monkeys.design.capability.ontologyManagement.filter.allGroups",
    filterAddOrGroup:
      "monkeys.design.capability.ontologyManagement.filter.addOrGroup",
    filterNoOrGroups:
      "monkeys.design.capability.ontologyManagement.filter.noOrGroups",
    filterOrGroup:
      "monkeys.design.capability.ontologyManagement.filter.orGroup",
    filterDeleteGroup:
      "monkeys.design.capability.ontologyManagement.filter.deleteGroup",
    filterSupplement:
      "monkeys.design.capability.ontologyManagement.filter.supplement",
    filterConfigureSupplement:
      "monkeys.design.capability.ontologyManagement.filter.configureSupplement",
    filterClearSupplement:
      "monkeys.design.capability.ontologyManagement.filter.clearSupplement",
    filterSupplementMode:
      "monkeys.design.capability.ontologyManagement.filter.supplementMode",
    filterModeOr: "monkeys.design.capability.ontologyManagement.filter.modeOr",
    filterModeAnd:
      "monkeys.design.capability.ontologyManagement.filter.modeAnd",
    filterModeCombination:
      "monkeys.design.capability.ontologyManagement.filter.modeCombination",
    filterRequiredAll:
      "monkeys.design.capability.ontologyManagement.filter.requiredAll",
    filterRequiredAny:
      "monkeys.design.capability.ontologyManagement.filter.requiredAny",
    filterAdvancedRules:
      "monkeys.design.capability.ontologyManagement.filter.advancedRules",
    filterAdvancedRulesDescription:
      "monkeys.design.capability.ontologyManagement.filter.advancedRulesDescription",
    filterRemoveAdvancedRules:
      "monkeys.design.capability.ontologyManagement.filter.removeAdvancedRules",
    defaultViewTemplates:
      "monkeys.design.capability.ontologyManagement.field.defaultViewTemplates",
    markerExists:
      "monkeys.design.capability.ontologyManagement.field.markerExists",
    targetOntology:
      "monkeys.design.capability.ontologyManagement.field.targetOntology",
    deleteTemplate:
      "monkeys.design.capability.ontologyManagement.action.deleteTemplate",
    deleteMarker:
      "monkeys.design.capability.ontologyManagement.action.deleteMarker",
    createDefaultViews:
      "monkeys.design.capability.ontologyManagement.action.createDefaultViews",
    techpackPreset:
      "monkeys.design.capability.ontologyManagement.action.techpackPreset",
    trendPreset:
      "monkeys.design.capability.ontologyManagement.action.trendPreset",
    addTemplate:
      "monkeys.design.capability.ontologyManagement.action.addTemplate",
    noTemplates:
      "monkeys.design.capability.ontologyManagement.empty.noTemplates",
    descriptionField:
      "monkeys.design.capability.ontologyManagement.field.description",
    bodyKind: "monkeys.design.capability.ontologyManagement.field.bodyKind",
    visible: "monkeys.design.capability.ontologyManagement.field.visible",
    kernelReadAllTeams:
      "monkeys.design.capability.ontologyManagement.field.kernelReadAllTeams",
    publicRead: "monkeys.design.capability.ontologyManagement.field.publicRead",
    publicWrite:
      "monkeys.design.capability.ontologyManagement.field.publicWrite",
    customizeViewModes:
      "monkeys.design.capability.ontologyManagement.field.customizeViewModes",
    availableViewModes:
      "monkeys.design.capability.ontologyManagement.field.availableViewModes",
    defaultViewMode:
      "monkeys.design.capability.ontologyManagement.field.defaultViewMode",
    viewModeTable:
      "monkeys.design.capability.ontologyManagement.field.viewMode.table",
    viewModeCard:
      "monkeys.design.capability.ontologyManagement.field.viewMode.card",
    viewModeGallery:
      "monkeys.design.capability.ontologyManagement.field.viewMode.gallery",
    viewModeTrendMatrix:
      "monkeys.design.capability.ontologyManagement.field.viewMode.trendMatrix",
    selectAtLeastOneViewMode:
      "monkeys.design.capability.ontologyManagement.field.validation.selectAtLeastOneViewMode",
    profile: "monkeys.design.capability.ontologyManagement.field.profile",
    sourceOntologyId:
      "monkeys.design.capability.ontologyManagement.field.sourceOntologyId",
    viewId: "monkeys.design.capability.ontologyManagement.field.viewId",
    name: "monkeys.design.capability.ontologyManagement.field.name",
    indexMode: "monkeys.design.capability.ontologyManagement.field.indexMode",
    parentId: "monkeys.design.capability.ontologyManagement.field.parentId",
    viewType:
      "monkeys.design.capability.ontologyManagement.field.viewType.label",
    viewTypeFilter:
      "monkeys.design.capability.ontologyManagement.field.viewType.filter",
    viewTypeContainer:
      "monkeys.design.capability.ontologyManagement.field.viewType.container",
    sourceContainerViewId:
      "monkeys.design.capability.ontologyManagement.field.sourceContainerViewId",
    displayConfig:
      "monkeys.design.capability.ontologyManagement.field.displayConfig",
    sort: "monkeys.design.capability.ontologyManagement.field.sort",
    managedFileId:
      "monkeys.design.capability.ontologyManagement.field.managedFileId",
    mode: "monkeys.design.capability.ontologyManagement.field.mode",
    columnId: "monkeys.design.capability.ontologyManagement.field.columnId",
    containerViewId:
      "monkeys.design.capability.ontologyManagement.field.containerViewId",
    type: "monkeys.design.capability.ontologyManagement.field.type",
    config: "monkeys.design.capability.ontologyManagement.field.config",
    scopeContainerViewId:
      "monkeys.design.capability.ontologyManagement.field.scopeContainerViewId",
    attached:
      "monkeys.design.capability.ontologyManagement.field.attached.label",
    attachedTrue:
      "monkeys.design.capability.ontologyManagement.field.attached.true",
    attachedFalse:
      "monkeys.design.capability.ontologyManagement.field.attached.false",
    pageSize: "monkeys.design.capability.ontologyManagement.field.pageSize",
    tagGroupIds:
      "monkeys.design.capability.ontologyManagement.field.tagGroupIds",
    featureColumnIds:
      "monkeys.design.capability.ontologyManagement.field.featureColumnIds",
    basicFieldIds:
      "monkeys.design.capability.ontologyManagement.field.basicFieldIds",
    columnType:
      "monkeys.design.capability.ontologyManagement.field.columnType.label",
    columnTypeFeature:
      "monkeys.design.capability.ontologyManagement.field.columnType.feature",
    columnTypePreview:
      "monkeys.design.capability.ontologyManagement.field.columnType.preview",
    featureColumnId:
      "monkeys.design.capability.ontologyManagement.field.featureColumnId",
    itemLimit: "monkeys.design.capability.ontologyManagement.field.itemLimit",
    shareOperation:
      "monkeys.design.capability.ontologyManagement.field.shareOperation.label",
    shareOperationUpsert:
      "monkeys.design.capability.ontologyManagement.field.shareOperation.upsert",
    shareOperationRevoke:
      "monkeys.design.capability.ontologyManagement.field.shareOperation.revoke",
    targetType:
      "monkeys.design.capability.ontologyManagement.field.targetType.label",
    targetTypeUser:
      "monkeys.design.capability.ontologyManagement.field.targetType.user",
    targetTypeTeam:
      "monkeys.design.capability.ontologyManagement.field.targetType.team",
    targetId: "monkeys.design.capability.ontologyManagement.field.targetId",
    permissions:
      "monkeys.design.capability.ontologyManagement.field.permissions",
    expiresAt: "monkeys.design.capability.ontologyManagement.field.expiresAt",
    actions: Object.freeze({
      "ontology-create":
        "monkeys.design.capability.ontologyManagement.action.ontologyCreate",
      "ontology-update":
        "monkeys.design.capability.ontologyManagement.action.ontologyUpdate",
      "ontology-delete":
        "monkeys.design.capability.ontologyManagement.action.ontologyDelete",
      "ontology-marker":
        "monkeys.design.capability.ontologyManagement.action.ontologyMarker",
      "ontology-default-views":
        "monkeys.design.capability.ontologyManagement.action.ontologyDefaultViews",
      "ontology-snapshot":
        "monkeys.design.capability.ontologyManagement.action.ontologySnapshot",
      "ontology-import-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportJsonl",
      "ontology-import-records-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportRecordsJsonl",
      "ontology-import-tag-relations-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportTagRelationsJsonl",
      "ontology-import-text-column-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportTextColumnJsonl",
      "ontology-import-json-column-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportJsonColumnJsonl",
      "ontology-import-relation-column-jsonl":
        "monkeys.design.capability.ontologyManagement.action.ontologyImportRelationColumnJsonl",
      "feature-column-create":
        "monkeys.design.capability.ontologyManagement.action.featureColumnCreate",
      "feature-column-update":
        "monkeys.design.capability.ontologyManagement.action.featureColumnUpdate",
      "feature-column-attachment-set":
        "monkeys.design.capability.ontologyManagement.action.featureColumnAttachmentSet",
      "view-export-jsonl":
        "monkeys.design.capability.ontologyManagement.action.viewExportJsonl",
      "feature-column-images-export":
        "monkeys.design.capability.ontologyManagement.action.featureColumnImagesExport",
      "view-create":
        "monkeys.design.capability.ontologyManagement.action.viewCreate",
      "view-update":
        "monkeys.design.capability.ontologyManagement.action.viewUpdate",
      "view-delete":
        "monkeys.design.capability.ontologyManagement.action.viewDelete",
      "view-share":
        "monkeys.design.capability.ontologyManagement.action.viewShare",
    }),
  }),
  ontologyTrendMatrix: Object.freeze({
    label: "monkeys.design.capability.ontologyTrendMatrix.label",
    row: "monkeys.design.capability.ontologyTrendMatrix.row",
    window: "monkeys.design.capability.ontologyTrendMatrix.window",
    select: "monkeys.design.capability.ontologyTrendMatrix.select",
  }),
  dataContextBar: Object.freeze({
    label: "monkeys.design.capability.dataContextBar.label",
    filter: "monkeys.design.capability.dataContextBar.filter",
    searchLabel: "monkeys.design.capability.dataContextBar.search.label",
    searchPlaceholder:
      "monkeys.design.capability.dataContextBar.search.placeholder",
    clear: "monkeys.design.capability.dataContextBar.clear",
    clearAll: "monkeys.design.capability.dataContextBar.clearAll",
    tagFilterClear: "monkeys.design.capability.dataContextBar.tagFilterClear",
    filterDescription:
      "monkeys.design.capability.dataContextBar.filterDescription",
    tagScope: "monkeys.design.capability.dataContextBar.tagScope",
    currentViewTags: "monkeys.design.capability.dataContextBar.currentViewTags",
    allTags: "monkeys.design.capability.dataContextBar.allTags",
    panelFilter: "monkeys.design.capability.dataContextBar.panelFilter",
    searchTags: "monkeys.design.capability.dataContextBar.searchTags",
    noAvailableTags: "monkeys.design.capability.dataContextBar.noAvailableTags",
    loadedAll: "monkeys.design.capability.dataContextBar.loadedAll",
    refreshTags: "monkeys.design.capability.dataContextBar.refreshTags",
    confirm: "monkeys.design.capability.dataContextBar.confirm",
    tagPanel: "monkeys.design.capability.dataContextBar.tagPanel",
    selectPanel: "monkeys.design.capability.dataContextBar.selectPanel",
    noPanels: "monkeys.design.capability.dataContextBar.noPanels",
    noPanelGroups: "monkeys.design.capability.dataContextBar.noPanelGroups",
    singleSelect: "monkeys.design.capability.dataContextBar.singleSelect",
    multiSelect: "monkeys.design.capability.dataContextBar.multiSelect",
    defaultGroup: "monkeys.design.capability.dataContextBar.defaultGroup",
    more: "monkeys.design.capability.dataContextBar.more",
    dashboardContext:
      "monkeys.design.capability.dataContextBar.dashboardContext",
    contextCount: "monkeys.design.capability.dataContextBar.contextCount",
    fields: Object.freeze({
      search: "monkeys.design.capability.dataContextBar.field.search",
      tagIds: "monkeys.design.capability.dataContextBar.field.tagIds",
      tagGroupIds: "monkeys.design.capability.dataContextBar.field.tagGroupIds",
      timeFrom: "monkeys.design.capability.dataContextBar.field.timeFrom",
      timeTo: "monkeys.design.capability.dataContextBar.field.timeTo",
      clickedField:
        "monkeys.design.capability.dataContextBar.field.clickedField",
      clickedValue:
        "monkeys.design.capability.dataContextBar.field.clickedValue",
      dashboardDrilldown:
        "monkeys.design.capability.dataContextBar.field.dashboardDrilldown",
    }),
  }),
});

export const DESIGN_CAPABILITY_NATIVE_ANALYTICS_MESSAGES = Object.freeze({
  "en-US": Object.freeze({
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.markerDescription]: "Configure the ontology marker and default views.",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.label]: "Marker name",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.targetOntology]: "Target ontology",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateKey]: "Template key",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateName]: "View name",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateDescription]: "View description",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateTags]: "Tag filters",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateTagsDescription]: "Choose the tags included, matched, or excluded by this view.",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.creatorCurrentUser]: "Only show records created by the current user",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.creatorCurrentUserShort]: "Current user",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplatesDescription]: "Configure default views and their filters for this ontology.",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplate]: "Default view template",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultSelectedView]: "Open by default",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tagFilterEnabled]: "Tag filters configured",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tagFilterEmpty]: "No tag filters",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tableColumnsSummary]: "{count} table columns configured",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.editTemplateDetails]: "Edit view template",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.editTemplateDetailsDescription]: "Configure the name, order, and filters.",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplates]: "Default view templates",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.markerExists]: "Ontology marker exists",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterInclude]: "Include all",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAny]: "Match any",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterExclude]: "Exclude",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterNoTags]: "No matching tags",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSearch]: "Search tags",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterTagGroup]: "Tag group",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAllGroups]: "All tag groups",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAddOrGroup]: "Add OR group",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterNoOrGroups]: "No OR groups",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterOrGroup]: "OR group {n}",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterDeleteGroup]: "Delete group",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSupplement]: "Supplement rules for {name}",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterConfigureSupplement]: "Configure supplement rules",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterClearSupplement]: "Clear supplement rules",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSupplementMode]: "Match mode",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeOr]: "Any condition (OR)",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeAnd]: "All conditions (AND)",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeCombination]: "Combined conditions",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRequiredAll]: "Require all tags",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRequiredAny]: "Require at least one tag",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAdvancedRules]: "{count} advanced rules",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAdvancedRulesDescription]: "Existing rules are preserved unless explicitly removed.",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRemoveAdvancedRules]: "Remove advanced rules",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.deleteTemplate]: "Delete template",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.deleteMarker]: "Delete marker",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.createDefaultViews]: "Create default views",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.addTemplate]: "Add view template",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.noTemplates]: "No default view templates",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.actions["ontology-marker"]]: "Set ontology marker",
    "monkeys.design.capability.pagination.previous": "Previous page",
    "monkeys.design.capability.pagination.next": "Next page",
    "monkeys.design.iconPicker.confirm": "Confirm",
    "monkeys.design.iconPicker.categories": "Categories",
    "monkeys.design.iconPicker.icon": "Icon",
    "monkeys.design.iconPicker.choose": "Choose an icon",
    "monkeys.design.iconPicker.current": "Current icon",
    "monkeys.design.iconPicker.reset": "Reset",
    "monkeys.design.iconPicker.search": "Search icons",
    "monkeys.design.iconPicker.category": "Category",
    "monkeys.design.iconPicker.background": "Background color",
    "monkeys.design.iconPicker.upload": "Upload icon",
    "monkeys.design.iconPicker.uploadFailed": "Icon upload failed",
    "monkeys.design.iconPicker.loading": "Loading icons",
    "monkeys.design.iconPicker.retry": "Retry",
    "monkeys.design.iconPicker.empty": "No matching icons",
    "monkeys.design.iconPicker.close": "Close",
    "monkeys.design.iconPicker.emoji": "Emoji",
    "monkeys.design.iconPicker.catalogFailed": "Unable to load icons",

    "monkeys.design.capability.choicePicker.label": "Choice picker",
    "monkeys.design.capability.choicePicker.description": "Search and select a paginated collection.",
    "monkeys.design.capability.runtimeTerminal.status": "Terminal",
    "monkeys.design.capability.runtimeTerminal.waiting": "Connecting to terminal…",
    "monkeys.design.capability.recordEditor.add": "Add item",
    "monkeys.design.capability.recordEditor.remove": "Remove item",
    "monkeys.design.capability.recordEditor.moveUp": "Move up",
    "monkeys.design.capability.recordEditor.moveDown": "Move down",
    "monkeys.design.capability.recordEditor.reset": "Reset",
    "monkeys.design.capability.filePicker.label": "Choose file",
    "monkeys.design.capability.filePicker.description": "Select a local file for a governed action.",
    "monkeys.design.capability.filePicker.cancel": "Clear file",
    "monkeys.design.capability.filePicker.tooLarge": "The file exceeds the allowed size.",
    "monkeys.design.capability.filePicker.invalidType": "Choose a supported file type.",
    "monkeys.design.capability.filePicker.registrationFailed": "The file could not be selected. Try again.",
    "monkeys.design.capability.recordEditor.date.invalid": "Enter a valid date and time within the allowed range.",
    "monkeys.design.capability.recordEditor.pick": "Choose",
    "monkeys.design.capability.recordEditor.selectionSummary": "Selected: {{count}}",
    "monkeys.design.capability.recordEditor.secretKeep": "Keep existing",
    "monkeys.design.capability.recordEditor.secretMode": "{field} update mode",
    "monkeys.design.capability.recordEditor.secretReplace": "Replace",
    "monkeys.design.capability.recordEditor.secretClear": "Clear",

    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.inspect]: "Inspect observation",
    "monkeys.design.capability.summaryChart.label": "Summary chart",
    "monkeys.design.capability.dataToolbar.moreActions": "More actions",
    "monkeys.design.capability.summaryChart.description": "Compare numeric series and category totals.",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.noPoints]: "No observations in this range",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.point]: "{xLabel} {x}, {yLabel} {y}",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.label]: "Numeric series",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.description]: "Inspect numeric observations with range zoom and expansion.",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.start]: "Range start",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.end]: "Range end",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.reset]: "Reset range",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.expand]: "Expand chart",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.close]: "Close chart",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.resizeSidebar]: "Resize sidebar",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.collapseSidebar]:
      "Collapse sidebar",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.expandSidebar]: "Expand sidebar",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.resizeAside]:
      "Resize detail panel",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyNavigator.moreActions]: "More actions",
    [DESIGN_CAPABILITY_I18N_KEYS.dataToolbar.addRow]: "Add row",
    [DESIGN_CAPABILITY_I18N_KEYS.dataToolbar.blankRowName]: "Blank Row",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.label]:
      "Ontology trend matrix",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.row]: "Row",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.window]:
      "Visible rows {start}-{end} of {total}",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.select]:
      "Select {row}, {column}, {value}",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.label]:
      "Data filters and drilldown context",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.filter]: "Filters",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchLabel]: "Search data",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchPlaceholder]: "Search",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.clear]: "Clear",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.clearAll]: "Clear all",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagFilterClear]: "Clear",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.filterDescription]:
      "Filter assets by selecting tags via tag panel or manual search.",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagScope]: "Tag scope",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.currentViewTags]:
      "Current view",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.allTags]: "All tags",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.panelFilter]: "Panel filter",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchTags]: "Search tags",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noAvailableTags]:
      "No available tags",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.loadedAll]: "All loaded",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.refreshTags]: "Refresh tags",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.confirm]: "Confirm",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagPanel]: "Tag panel",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.selectPanel]: "Select a panel",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noPanels]:
      "No available panels",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noPanelGroups]:
      "No tag groups in this panel",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.singleSelect]: "Single select",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.multiSelect]: "Multi select",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.defaultGroup]: "Default group",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.more]: "+{count} more",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.dashboardContext]:
      "Dashboard context",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.contextCount]:
      "{count} context values",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.search]: "Search",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.tagIds]: "Tags",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.tagGroupIds]:
      "Tag groups",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.timeFrom]: "From",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.timeTo]: "To",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.clickedField]:
      "Drilldown field",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.clickedValue]:
      "Drilldown value",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.dashboardDrilldown]:
      "Dashboard drilldown",
  }),
  "zh-CN": Object.freeze({
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.markerDescription]: "配置仓库标记和默认视图。",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.label]: "标记名称",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.targetOntology]: "目标仓库",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateKey]: "模板标识",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateName]: "视图名称",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateDescription]: "视图描述",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateTags]: "标签筛选",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.templateTagsDescription]: "设置该视图包含、匹配或排除的标签。",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.creatorCurrentUser]: "仅显示当前用户创建的数据",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.creatorCurrentUserShort]: "当前用户",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplatesDescription]: "为仓库配置默认视图及其筛选条件。",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplate]: "默认视图模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultSelectedView]: "默认打开",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tagFilterEnabled]: "已配置标签筛选",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tagFilterEmpty]: "未配置标签筛选",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.tableColumnsSummary]: "已配置 {count} 个表格列",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.editTemplateDetails]: "编辑视图模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.editTemplateDetailsDescription]: "配置名称、排序和筛选条件。",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.defaultViewTemplates]: "默认视图模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.markerExists]: "已有仓库标记",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterInclude]: "全部包含",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAny]: "匹配任意",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterExclude]: "排除",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterNoTags]: "没有匹配的标签",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSearch]: "搜索标签",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterTagGroup]: "标签组",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAllGroups]: "全部标签组",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAddOrGroup]: "添加或条件组",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterNoOrGroups]: "暂无或条件组",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterOrGroup]: "或条件组 {n}",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterDeleteGroup]: "删除条件组",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSupplement]: "{name} 的补充规则",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterConfigureSupplement]: "配置补充规则",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterClearSupplement]: "清除补充规则",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterSupplementMode]: "匹配方式",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeOr]: "任意条件（OR）",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeAnd]: "全部条件（AND）",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterModeCombination]: "组合条件",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRequiredAll]: "必须包含全部标签",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRequiredAny]: "至少包含一个标签",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAdvancedRules]: "{count} 项高级规则",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterAdvancedRulesDescription]: "已有规则将保留，除非明确移除。",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.filterRemoveAdvancedRules]: "移除高级规则",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.deleteTemplate]: "删除模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.deleteMarker]: "删除仓库标记",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.createDefaultViews]: "创建默认视图",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.addTemplate]: "添加视图模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.noTemplates]: "暂无默认视图模板",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyManagement.actions["ontology-marker"]]: "设置仓库标记",
    "monkeys.design.capability.pagination.previous": "上一页",
    "monkeys.design.capability.pagination.next": "下一页",
    "monkeys.design.iconPicker.confirm": "确认",
    "monkeys.design.iconPicker.categories": "分类",
    "monkeys.design.iconPicker.icon": "图标",
    "monkeys.design.iconPicker.choose": "选择图标",
    "monkeys.design.iconPicker.current": "当前图标",
    "monkeys.design.iconPicker.reset": "重置",
    "monkeys.design.iconPicker.search": "搜索图标",
    "monkeys.design.iconPicker.category": "分类",
    "monkeys.design.iconPicker.background": "背景颜色",
    "monkeys.design.iconPicker.upload": "上传图标",
    "monkeys.design.iconPicker.uploadFailed": "图标上传失败",
    "monkeys.design.iconPicker.loading": "正在加载图标",
    "monkeys.design.iconPicker.retry": "重试",
    "monkeys.design.iconPicker.empty": "没有匹配的图标",
    "monkeys.design.iconPicker.close": "关闭",
    "monkeys.design.iconPicker.emoji": "表情",
    "monkeys.design.iconPicker.catalogFailed": "无法加载图标",

    "monkeys.design.capability.choicePicker.label": "选项选择器",
    "monkeys.design.capability.choicePicker.description": "搜索并选择分页集合中的选项。",
    "monkeys.design.capability.summaryChart.label": "汇总图表",
    "monkeys.design.capability.dataToolbar.moreActions": "更多操作",
    "monkeys.design.capability.summaryChart.description": "比较数值序列与分类汇总。",
    "monkeys.design.capability.runtimeTerminal.status": "终端",
    "monkeys.design.capability.runtimeTerminal.waiting": "正在连接终端…",
    "monkeys.design.capability.recordEditor.add": "添加条目",
    "monkeys.design.capability.recordEditor.remove": "删除条目",
    "monkeys.design.capability.recordEditor.moveUp": "上移",
    "monkeys.design.capability.recordEditor.moveDown": "下移",
    "monkeys.design.capability.recordEditor.reset": "重置",
    "monkeys.design.capability.filePicker.label": "选择文件",
    "monkeys.design.capability.filePicker.description": "选择本地文件以执行受治理操作。",
    "monkeys.design.capability.filePicker.cancel": "清除文件",
    "monkeys.design.capability.filePicker.tooLarge": "文件大小超过允许范围。",
    "monkeys.design.capability.filePicker.invalidType": "请选择支持的文件类型。",
    "monkeys.design.capability.filePicker.registrationFailed": "无法选择该文件，请重试。",
    "monkeys.design.capability.recordEditor.date.invalid": "请输入允许范围内的有效日期和时间。",
    "monkeys.design.capability.recordEditor.pick": "选择",
    "monkeys.design.capability.recordEditor.selectionSummary": "已选 {{count}} 项",
    "monkeys.design.capability.recordEditor.secretKeep": "保留现有值",
    "monkeys.design.capability.recordEditor.secretMode": "{field} 更新方式",
    "monkeys.design.capability.recordEditor.secretReplace": "替换",
    "monkeys.design.capability.recordEditor.secretClear": "清除",

    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.inspect]: "查看观测点",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.noPoints]: "此范围内没有观测点",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.point]: "{xLabel} {x}, {yLabel} {y}",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.label]: "数值序列",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.description]: "查看数值观测，缩放范围并放大图表。",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.start]: "范围起点",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.end]: "范围终点",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.reset]: "重置范围",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.expand]: "放大图表",
    [DESIGN_CAPABILITY_I18N_KEYS.numericSeries.close]: "关闭图表",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.resizeSidebar]: "调整侧边栏宽度",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.collapseSidebar]: "收起侧边栏",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.expandSidebar]: "展开侧边栏",
    [DESIGN_CAPABILITY_I18N_KEYS.shellLayout.resizeAside]: "调整详情侧边栏宽度",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyNavigator.moreActions]: "更多操作",
    [DESIGN_CAPABILITY_I18N_KEYS.dataToolbar.addRow]: "添加一行",
    [DESIGN_CAPABILITY_I18N_KEYS.dataToolbar.blankRowName]: "空白行",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.label]: "本体趋势矩阵",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.row]: "行",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.window]:
      "当前显示第 {start}-{end} 行，共 {total} 行",
    [DESIGN_CAPABILITY_I18N_KEYS.ontologyTrendMatrix.select]:
      "选择 {row}、{column}、{value}",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.label]: "数据筛选与钻取上下文",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.filter]: "筛选",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchLabel]: "搜索数据",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchPlaceholder]: "搜索",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.clear]: "清除",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.clearAll]: "全部清除",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagFilterClear]: "清空",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.filterDescription]:
      "通过标签面板或手动搜索，选择用于过滤资产的 Tag。",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagScope]: "标签范围",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.currentViewTags]: "当前视图",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.allTags]: "全部标签",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.panelFilter]: "面板筛选",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.searchTags]: "搜索标签",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noAvailableTags]:
      "暂无可用标签",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.loadedAll]: "已加载全部",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.refreshTags]: "刷新标签",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.confirm]: "确定",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.tagPanel]: "标签面板",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.selectPanel]: "选择标签面板",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noPanels]: "暂无可用标签面板",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.noPanelGroups]:
      "当前面板没有标签组",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.singleSelect]: "单选",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.multiSelect]: "多选",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.defaultGroup]: "默认标签组",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.more]: "另有 {count} 项",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.dashboardContext]:
      "仪表盘上下文",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.contextCount]:
      "{count} 项上下文",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.search]: "搜索",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.tagIds]: "标签",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.tagGroupIds]: "标签组",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.timeFrom]: "开始时间",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.timeTo]: "结束时间",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.clickedField]:
      "钻取字段",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.clickedValue]: "钻取值",
    [DESIGN_CAPABILITY_I18N_KEYS.dataContextBar.fields.dashboardDrilldown]:
      "仪表盘钻取",
  }),
});
